<div class="page">
	<h1>Self-test</h1>

	<p class="masterStatus" [ngClass]="{'pass': masterStatus === true, 'fail': masterStatus === false}">
		{{ masterStatus == null ? "RUNNING..." : masterStatus ? "OK" : "FAIL" }}
	</p>

	<h2>Static Data Tree</h2>
	<div id="static-data">
		<ng-container *ngFor="let item of staticDataRoot">
			<ng-container *ngTemplateOutlet="staticDataItemTemplate; context: { item: item }"></ng-container>
		</ng-container>
		<ng-template #staticDataItemTemplate let-item="item">
			<div class="staticDataItem" [ngClass]="{'noStaticData': item.noStaticData === true}">
				<span class="treeIndent" [innerHTML]="item.indent"></span><span class="static-data-type">{{item.type}}</span> - <span [innerHTML]="item.label"></span>
			</div>
			<ng-container *ngFor="let item of item.children">
				<ng-container *ngTemplateOutlet="staticDataItemTemplate; context: { item: item }"></ng-container>
			</ng-container>
		</ng-template>
	</div>

	<h2>API Requests</h2>
	<table>
		<tr>
			<th>Result</th>
			<th>HttpStatus</th>
			<th>Milliseconds</th>
			<th>Url</th>
			<th>Data/Message</th>
		</tr>
		<tr *ngFor="let test of testTasks" [ngClass]="{'pass': test.result === true, 'fail': test.result === false}">
			<td class="result centre">{{ test.result == null ? "" : test.result ? "OK" : "FAIL" }}</td>
			<td class="centre">{{ test.httpStatus }}</td>
			<td class="right">{{ test.durationMillis }}</td>
			<td class="monospace">{{ test.url }}</td>
			<td class="message monospace" #message [ngClass]="{'collapsed': test.result === true}"
				(click)="message.classList.toggle('collapsed')"
				title="{{ test.message }}">
				<div>{{ test.message }}</div>
			</td>
		</tr>
	</table>
</div>
